import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { auth, db, app } from "../../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import '../../styles/PaidServices.css';




const CancelSubscription = () => {
  // 状態管理
  const [isPaidUser, setIsPaidUser] = useState(false);
  const [expirationDate, setExpirationDate] = useState(null);
  const [subscriptionId, setSubscriptionId] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // サブスクリプション状態の確認
  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      const user = auth.currentUser;
      if (!user) {
        setErrorMessage("ユーザーがログインしていません。");
        return;
      }

      try {
        // Firestoreからサブスクリプション情報を取得
        const payCheckRef = doc(db, "pay_checked", user.uid);
        const payCheckSnap = await getDoc(payCheckRef);

        if (payCheckSnap.exists()) {
          const payCheckData = payCheckSnap.data();
          const expiration = payCheckData.expiration.toDate();
          setSubscriptionId(payCheckData.subscriptionId);

          const expirationEndOfDay = new Date(
            expiration.getFullYear(),
            expiration.getMonth(),
            expiration.getDate() + 1,
            0,
            0,
            0
          );

          // サブスクリプションが有効かを確認
          if (new Date() < expirationEndOfDay) {
            setIsPaidUser(true);
            setExpirationDate(expirationEndOfDay);
          }
        } else {
          setErrorMessage("サブスクリプション情報が見つかりません。");
        }
      } catch (error) {
        console.error("Error checking subscription status:", error.message);
        setErrorMessage("サブスクリプション状態の確認中にエラーが発生しました。");
      }
    };

    checkSubscriptionStatus();
  }, []);


  const handleCancelSubscription = async () => {
    if (!subscriptionId) {
      setErrorMessage("サブスクリプションIDが見つかりません。");
      return;
    }
  
    setLoading(true); // ローディング開始
    setErrorMessage("");
    setSuccessMessage("");
  
    try {
      const functions = getFunctions(app, "asia-northeast2");
      const cancelSubscription = httpsCallable(functions, "cancelSubsc");
  
      console.log("Sending request to cancel subscription with ID:", subscriptionId);
      const result = await cancelSubscription({ subscriptionId });
  
      console.log("Cancel subscription response:", result.data);
  
      if (result.data.success) {
        setSuccessMessage("サブスクリプションが正常に解約されました。");
        setIsPaidUser(false); // 解約後の状態変更
        setSubscriptionId(""); // サブスクリプションIDをクリア
      } else {
        setErrorMessage(result.data.message || "解約に失敗しました。");
      }
    } catch (error) {
      console.error("Error cancelling subscription:", error.message);
      setErrorMessage(error.message || "解約処理中にエラーが発生しました。");
    } finally {
      setLoading(false); // ローディング終了
    }
  };
  
  
  

  // コンポーネントの表示
// コンポーネントの表示
return (
  <div className="cancel-container">
    {successMessage ? (
      // キャンセル完了後のUI
      <div>
        <div className="header">
          <Link to="/paidservices" className="back-link-cont">
            ←
          </Link>
          <p className="settings-title-cont">解約ページ</p>
        </div>
        <h3>有料プランのキャンセルが完了しました</h3>
        <div className="cancel-content">
          <p className="cancel-description">
            有料プランのご利用ありがとうございました。また、ご利用ください。
          </p>
        </div>
      </div>
    ) : (
      // 通常のキャンセル手続き画面
      <div>
        <div className="header">
          <Link to="/paidservices" className="back-link-cont">
            ←
          </Link>
          <p className="settings-title-cont">解約ページ</p>
        </div>
        <h3>有料プランのキャンセルは以下のボタンを押すと完了します</h3>
        <div className="cancel-content">
          <p className="cancel-description">
            サブスクリプションサービスのキャンセル後も、<span className="cancel-bold">
              {expirationDate &&
                `${expirationDate.getFullYear()}年${expirationDate.getMonth() + 1}月${expirationDate.getDate()}日 0:00 までメッセージ・通話機能をご利用いただけます。`}
            </span>
            キャンセルにあたってエラーや不具合等が生じた場合には、お問合せフォームにご連絡ください。
          </p>
          <br />
          {isPaidUser ? (
            <>
              <button
                onClick={handleCancelSubscription}
                className={`cancel-button ${loading ? "disabled" : ""}`}
                disabled={loading}
              >
                {loading ? "処理中..." : "キャンセル手続きの完了"}
              </button>
            </>
          ) : (
            <p>現在、有料プランに加入していません。</p>
          )}
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
      </div>
    )}
  </div>
);

};

export default CancelSubscription;
